export default __webpack_public_path__ + "static/media/four.7070c8bb.svg";